import styled from "styled-components"

import { spacing } from "@izettle/otto"
import { useLayout } from "@izettle/react-spa"

import { theme } from "@/theme"

export const PageLayout = styled.div<{ hideLayout?: boolean }>`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding-bottom: ${spacing.xxLarge};

  @media ${theme.devices.mobile} {
    max-width: 360px;
  }

  // Breakpoint values from react-spa/src/styles.tsx
  @media ${theme.devices.desktop} {
    padding-bottom: ${spacing.huge};
  }

  ${({ hideLayout }) =>
    hideLayout &&
    `
    padding: ${spacing.small} ${spacing.small} ${spacing.xxLarge} ${spacing.small};

    @media (min-width: ${theme.devices.tablet}) {
      padding: ${spacing.large} ${spacing.small} ${spacing.xxLarge} ${spacing.small};
    }
  `}
`
type PageWrapperProps = {
  className?: string
  children: React.ReactNode
}

export const PageWrapper: React.FC<PageWrapperProps> = ({ className, children }) => {
  const { hideLayout } = useLayout()

  return (
    <PageLayout hideLayout={hideLayout} className={className}>
      {children}
    </PageLayout>
  )
}
